export default {
  name: 'nestMenu2',
  data() {
    return {
      value: 2
    };
  }
};